import React from 'react';
import { FileText } from 'lucide-react';
import LegalLayout from '../LegalLayout';

const TermsConditions = () => {
  const accentColor = '#5865F2';
  const lastUpdated = 'May 6, 2026';

  return (
    <LegalLayout app="Open Claw Discord Application" docType="Terms of Service" icon={FileText} lastUpdated={lastUpdated}>
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>
                Acceptance of Terms
              </h2>
              <p className="leading-relaxed">
                By accessing or using the Open Claw Discord application (the "Application"), you agree to
                these Terms of Service. If you do not agree, do not use the Application.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>
                Description of Service
              </h2>
              <p className="mb-4 leading-relaxed">
                Open Claw is a Discord-based communication and operations interface built by Feral Techlabs.
                It may provide AI-assisted replies, workflow coordination, status updates, automation routing,
                and operational visibility across internal or approved environments.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>
                Permitted Use
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Use the Application only for lawful purposes</li>
                <li>Do not abuse, overload, reverse engineer, or disrupt the service</li>
                <li>Do not use the Application to harass, impersonate, or attack others</li>
                <li>Do not submit content you do not have the right to share</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>
                AI and Automation Disclaimer
              </h2>
              <p className="leading-relaxed">
                Responses may be generated or assisted by automated systems and large language models.
                Outputs may be incomplete, delayed, or incorrect. You are responsible for reviewing important
                actions, approvals, and decisions before relying on them.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>
                Availability
              </h2>
              <p className="leading-relaxed">
                We may modify, suspend, restrict, or discontinue the Application at any time without notice.
                We do not guarantee uninterrupted availability or delivery.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>
                Third-Party Platforms
              </h2>
              <p className="leading-relaxed">
                The Application operates on top of Discord and may rely on other third-party model, hosting,
                messaging, or infrastructure providers. Your use of those platforms remains subject to their
                own terms and policies.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>
                Intellectual Property
              </h2>
              <p className="leading-relaxed">
                The Application, its configuration, branding, workflows, and related materials are owned by
                Feral Techlabs or its licensors. Except where allowed by law, you may not copy, sell,
                sublicense, or redistribute the service without permission.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>
                Disclaimer of Warranties
              </h2>
              <p className="leading-relaxed">
                The Application is provided on an "as is" and "as available" basis without warranties of any
                kind, express or implied, including merchantability, fitness for a particular purpose, or
                non-infringement.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>
                Limitation of Liability
              </h2>
              <p className="leading-relaxed">
                To the maximum extent permitted by law, Feral Techlabs will not be liable for indirect,
                incidental, special, consequential, or punitive damages arising from your use of or inability
                to use the Application.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>
                Changes to These Terms
              </h2>
              <p className="leading-relaxed">
                We may update these Terms from time to time by posting a revised version at this page.
                Continued use of the Application after changes are posted constitutes acceptance of the
                updated Terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>
                Contact
              </h2>
              <p className="leading-relaxed">
                Questions about these Terms can be sent to{' '}
                <a href="mailto:tanushgupta11@gmail.com" style={{ color: accentColor }} className="transition-colors">
                  tanushgupta11@gmail.com
                </a>
                .
              </p>
            </section>
          </div>
    </LegalLayout>
  );
};

export default TermsConditions;
